import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const BlastLogoSquare = t0 => {
  const $ = _c(12);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <rect fill="#000" height={24} rx={0} width={24} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <g fill="none" fillRule="nonzero">{t3}<g fill="#FCFC03"><path d="m16.895 11.897 2.68-1.336.925-2.836-1.848-1.345H6.346L3.5 8.494h14.466l-.769 2.378h-5.8l-.559 1.739h5.8l-1.628 5.005 2.718-1.345.97-3.001-1.821-1.336z" /><path d="m7.59 15.466 1.674-5.216-1.857-1.39-2.79 8.756H15.01l.696-2.15z" /></g></g>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== className || $[9] !== rest || $[10] !== t2) {
    t5 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t4}</svg>;
    $[8] = className;
    $[9] = rest;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export const BlastLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0Zm18.652 6.38H6.346L3.5 8.494h14.466l-.769 2.378h-5.8l-.559 1.739h5.8l-1.628 5.005 2.718-1.345.97-3.001-1.821-1.336.018-.037 2.68-1.336.925-2.836-1.848-1.345ZM7.407 8.86l-2.79 8.756H15.01l.696-2.15H7.59l1.674-5.216-1.857-1.39Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};